import { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { JawaMark } from "@/components/Logo";

export default function OrderHistoryPage() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | busy | sent

  const submit = async (e) => {
    e.preventDefault();
    setState("busy");
    try {
      await api.post("/orders/recover", { email });
      setState("sent");
    } catch (err) {
      toast.error(formatApiError(err));
      setState("idle");
    }
  };

  return (
    <div className="bg-jawa-ivory" data-testid="order-history-page">
      <Nav />
      <main className="flex min-h-screen items-center justify-center px-6 pt-24 pb-16">
        <div className="w-full max-w-md border border-jawa-stone bg-white p-10">
          <JawaMark className="h-10 w-10 text-jawa-espresso" />
          <h1 className="mt-6 font-serif text-3xl font-medium text-jawa-espresso">Your downloads</h1>
          {state === "sent" ? (
            <div data-testid="order-recover-sent">
              <p className="mt-4 flex items-start gap-2 text-sm leading-relaxed text-jawa-espresso/70">
                <MailCheck className="mt-0.5 h-4 w-4 shrink-0 text-jawa-turquoise" />
                If we hold purchases for this email, your download links are on their way to {email}.
              </p>
              <p className="mt-3 text-xs text-jawa-espresso/50">Check spam if nothing arrives in a few minutes.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6" data-testid="order-recover-form">
              <p className="text-sm leading-relaxed text-jawa-espresso/70">
                Enter the email you used at checkout and we'll send fresh download links for every guide
                you've purchased.
              </p>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                data-testid="order-recover-email"
                className="mt-6 w-full border-b border-jawa-stone bg-transparent py-3 text-sm text-jawa-espresso outline-none transition-colors placeholder:text-jawa-espresso/40 focus:border-jawa-espresso"
              />
              <button
                type="submit"
                disabled={state === "busy"}
                data-testid="order-recover-submit"
                className="mt-8 inline-flex w-full items-center justify-center gap-2 bg-jawa-espresso px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-jawa-ivory transition-colors hover:bg-jawa-terracotta disabled:opacity-60"
              >
                {state === "busy" && <Loader2 className="h-4 w-4 animate-spin" />}
                Email My Download Links
              </button>
            </form>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
